Object.defineProperty(Array.prototype, 'forEachAsync', {
  value: async function (fn) {
    for (let t of this) { await fn(t) }
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Array.prototype, 'insert', {
  value: function (index, ...items) {
    this.splice(index, 0, ...items);
  },
  enumerable: false,
  writable: false
});


Object.defineProperty(Array.prototype, 'remove', {
  value: function (element) {
    const index = this.indexOf(element)
    if (index !== -1) {
      this.splice(index, 1)
    }
  },
  enumerable: false,
  writable: false
});

Object.defineProperty(Array.prototype, 'removeByIndex', {
  value: function (index) {
    if (index !== -1) {
      this.splice(index, 1)
    }
  },
  enumerable: false,
  writable: false
});

export default {}
